import {PracticeId} from "../../constants/practiceIds";
import monolith from "../../utils/fetch/fetches";

/**
 * Create a new patient with the given info.
 */
export async function createPatient(request: CreatePatientRequest): Promise<CreatePatientResponse> {
  const data = {
    patient: {
      ...request,
      practiceId: PracticeId.CARBON,
    },
  };
  const response = await monolith()("/hib/patients/account", {
    method: "POST",
    body: JSON.stringify(data),
  });
  return response.json();
}

export enum Gender {
  Male = "Male",
  Female = "Female",
  Unknown = "Unknown",
}

type CreatePatientRequest = {
  phoneNumber: string; // no formatting. e.g. "12223334444"
  phoneNumberCountry: string; // e.g. "US"
  birthdate: string; // formatted "2020-09-02
  firstName: string;
  lastName: string;
  email: string;
  gender: Gender;
};

type CreatePatientResponse = {
  userId: string;
  patientId: string;
  userToken: string;
};
